<template lang="pug">
.uploader
  div(:class="['uploader__card', { 'uploader__card--loading': loading }]" @dragover='dragover' @dragleave='dragleave' @drop='drop')
    div(:class="['uploader__card__placeholder', { 'uploader__card__placeholder--readonly': onlyUpload }]" v-if='!data.length || onlyUpload')
      vm-icon(icon="cloud-upload-outline" size="2rem" v-if="!onlyUpload")
      label(for='files')
        span {{ $t('quotations.description_attached') }}
      vm-button(@click="onDialogFileOpen" :size="buttonSize" :icon="onlyUpload ? 'cloud-upload-outline' : ''")
        template(v-if="!onlyUpload") Buscar archivo
    div(class="uploader__card__grid" v-else-if='data.length && !onlyUpload')
      div(class="uploader__card__grid__item" v-for='(file, index) in data' :key="index")
        header
          img(:src='checkFormat(file.name)')
          .uploader__card__grid__item__dropdown
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="flat" icon="more-vertical" color="#afbbc6" size="small")
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(v-if="file.id" @click="onShow(file)")
                  vm-icon(icon="edit-2-outline")
                  slot &nbsp;{{ $t('strings.view') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="onRemove(index, file)")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
        footer
          img(:src='checkFormat(file.name)')
          span {{ getFileNameFormated(file.name) }}
      vm-button(@click="onDialogFileOpen" :size="buttonSize" class="uploader__upload" icon="plus")
  input(class="uploader__file" id="files" type='file' :multiple='multiple' name='fields[files][]' @change='onChange' ref='file' :accept='acceptFiles')
</template>

<script>
export default {
  name: 'UploaderFile',
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    acceptFiles: {
      type: String,
      default: '.pdf,.dwg,.xls,.spread,.dxf,.xlsx'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    onlyUpload: {
      type: Boolean,
      default: false
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    loading: {
      type: Boolean,
      default: false
    },
    replace: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('attached-custom__card--dragover')) {
        event.currentTarget.classList.add('attached-custom__card--dragover')
      }
      this.$emit('dragover')
    },
    dragleave (event) {
      event.currentTarget.classList.remove('attached-custom__card--dragover')
      this.$emit('dragleave')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      event.currentTarget.classList.remove('attached-custom__card--dragover')
      this.$emit('drop', event.dataTransfer.files)
    },
    onShow () {
      this.$emit('onShow')
    },
    onRemove () {
      this.$emit('onRemove')
    },
    onChange () {
      this.$emit('drop', this.$refs.file.files)
    },
    onDialogFileOpen () {
      if (this.replace) {
        this.$refs.file.value = ''
      }
      this.$refs.file.click()
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      if (type === 'dwg' || type === 'dxf') {
        return require('@/assets/icons/auto.png')
      } else if (type === 'pdf') {
        return require('@/assets/icons/pdf.svg')
      } else if (type === 'xls' || type === 'spread' || type === 'xlsx') {
        return require('@/assets/icons/excel.svg')
      } else {
        return require('@/assets/icons/pdf.svg')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.uploader {
  margin: 20px 0;
  width: 100%;
  &__card {
    background-color: #F2F4F7;
    display: flex;
    min-height: 50px;
    border-radius: 8px;
    border: 3px dashed #B1B1B1;
    padding: 14px 35px;
    position: relative;
    &--dragover {
      background-color: rgba($color: var(--success), $alpha: 0.5);
      border: 3px dashed rgba($color: var(--success), $alpha: 1.0);
    }
    &__placeholder {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &--readonly {
        flex-direction: row;
        justify-content: space-between;
      }
      & label {
        & span {
          font-size: 14px;
          font-weight: 400;
          color: #8A8A8A;
        }
      }
      & button {
        font-weight: 700;
        font-size: 16px;
      }
    }
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
      &__item {
        background-color: white;
        border-radius: 0.5em;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 125px;
          border-bottom: 1px solid #f0f0f0;
          padding: 10px;
          position: relative;
          img {
            width: 50px;
          }
        }
        & footer {
          padding: 10px;
          display: flex;
          & img {
            width: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  &__file {
    display: none;
  }
  &__upload {
    position: absolute;
    bottom: 5px;
    right: 5px;
    border-radius: 50%;
  }
  // remove clasess
  &__text {
    font-weight: bold;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
</style>
